class InstallmentCalculator {
  constructor() {
    this.maxInstallments = parseInt(document.querySelector('[data-installment-max]')?.dataset.installmentMax || '10');
    this.minInstallmentValue = parseInt(document.querySelector('[data-installment-min]')?.dataset.installmentMin || '30000');
    this.init();
  }

  init() {
    if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode === false) {
      document.addEventListener('shopify:section:load', () => {
        this.updateSettingsFromDOM();
      });
    }

    if (typeof subscribe !== 'undefined') {
      subscribe('variantChange', (event) => {
        if (event.data && event.data.variant && event.data.variant.price) {
          this.updateInstallment(event.data.variant.price);
        }
      });
    }

    document.addEventListener('variant:change', (event) => {
      const { variant } = event.detail;
      if (variant && variant.price) {
        this.updateInstallment(variant.price);
      }
    });

    document.addEventListener('price:update', (event) => {
      const { price } = event.detail;
      if (price) {
        this.updateInstallment(price);
      }
    });
  }

  updateSettingsFromDOM() {
    const element = document.querySelector('[data-installment-max]');
    if (element) {
      this.maxInstallments = parseInt(element.dataset.installmentMax || '10');
      this.minInstallmentValue = parseInt(element.dataset.installmentMin || '30000');
    }
  }

  calculateInstallments(priceInCents) {
    let installments = Math.floor(priceInCents / this.minInstallmentValue);

    if (installments > this.maxInstallments) {
      installments = this.maxInstallments;
    }

    if (installments < 2) {
      return {
        count: 0,
        price: 0,
        total: priceInCents,
        shouldHide: true
      };
    }

    const installmentPrice = Math.floor(priceInCents / installments);

    return {
      count: installments,
      price: installmentPrice,
      total: priceInCents,
      shouldHide: false
    };
  }

  formatPrice(priceInCents) {
    const priceInReais = priceInCents / 100;
    return priceInReais.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  updateInstallment(priceInCents) {
    const installmentElements = document.querySelectorAll('.product-installment');
    
    if (installmentElements.length === 0) return;

    const calculation = this.calculateInstallments(priceInCents);
    
    installmentElements.forEach(element => {
      const textElement = element.querySelector('.product-installment__text');
      
      if (textElement && !calculation.shouldHide) {
        const formattedPrice = this.formatPrice(calculation.price);
        textElement.innerHTML = `ou ${calculation.count}x de R$ ${formattedPrice}`;
        element.style.display = 'block';
      } else {
        element.style.display = 'none';
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new InstallmentCalculator();
  });
} else {
  new InstallmentCalculator();
}